import React from 'react';
import { TblViewSpec } from './table-view.types';
import { TblFltStats } from './table.types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const TBL_CONTROLS_COLOR = '#FFFFFF';

export type TblTopControlsParams = {
    id: string;
    fltStats?: TblFltStats;
    views?: TblViewSpec[];
    currentViewId?: string;
    onViewChange?: (id: string) => void;
};

const TableTopControls = ({ id, fltStats, views, currentViewId, onViewChange }: TblTopControlsParams): JSX.Element => {
    const currentViewTitle = getViewTitle(views || [], currentViewId ?? '');

    const showFlt = hasFltStats(fltStats);
    const formatter = new Intl.NumberFormat('en-US');

    function handleViewChange(id: string): void {
        if (!!onViewChange && !!id) {
            onViewChange(id);
        }
    }

    function handleChange(e): void {
        handleViewChange(e.target.value);
    }

    return (
        <div
            id={id}
            className="wid-table-top-controls tbl-top-controls"
        >
            {views ? (
                <div className="tbl-views">
                    <label htmlFor={`${id}-table-views`}>
                        <div className="icon-badge-container">
                            <FontAwesomeIcon
                                icon={faFilter}
                                color={TBL_CONTROLS_COLOR}
                            />
                        </div>
                        Viewing:{' '}
                    </label>
                    <select
                        id={`${id}-table-views`}
                        className="table-views-droplist"
                        defaultValue={currentViewTitle}
                        onChange={handleChange}
                    >
                        {views.map(view => (
                            <option
                                key={view.key}
                                value={view.key}
                            >
                                {view.title}
                            </option>
                        ))}
                    </select>
                </div>
            ) : null}
            {showFlt && fltStats ? (
                <span className="tbl-flt">
                    <div className="icon-badge-container">
                        <FontAwesomeIcon
                            icon={faFilter}
                            color={TBL_CONTROLS_COLOR}
                        />
                    </div>
                    Filtering {formatter.format(fltStats.filtered)} of {formatter.format(fltStats.total)} items
                </span>
            ) : null}
        </div>
    );
};

export default TableTopControls;

function getViewTitle(views: TblViewSpec[], current: string): string {
    const foundView = views.find(v => {
        return v.key == current;
    });
    return !!foundView && !!foundView.title ? foundView.title : '';
}

function hasFltStats(fltStats: TblFltStats | undefined): boolean {
    return !!fltStats && !isNaN(fltStats.filtered) && !isNaN(fltStats.total);
}
